import { ConsentBox } from "@soyio/soyio-widget";
import type { SoyioTypes } from "@soyio/soyio-widget";

let consentBox: ConsentBox | null = null;

export type ConsentCheckboxChange = {
  isSelected: boolean;
  actionToken?: string;
};

const appearance: SoyioTypes.SoyioAppearance = {
  config: {
    consentControl: "checkbox",
  },
  theme: "soyio",
  variables: {
    fontFamily:
      "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif",
    colorPrimary: "#0B7A4B",
    colorSecondary: "#2563EB",
    colorBackground: "#FFFFFF",
    colorText: "#17231E",
    borderRadius: "0.75rem",
    borderWidth: "1px",
    borderStyle: "solid",
  },
  rules: {
    ".MainContainer": {
      borderColor: "#DCE8E2",
      borderRadius: "0.75rem",
    },
  },
};

export function destroyConsentBox() {
  consentBox?.unmount?.();
  consentBox = null;
}

export function mountConsentBox(params: {
  templateId: `constpl_${string}`;
  containerSelector: string;
  onCheckboxChange: (change: ConsentCheckboxChange) => void;
}) {
  destroyConsentBox();

  consentBox = new ConsentBox({
    consentTemplateId: params.templateId,
    mandatoryReconsentBehavior: "notice",
    isSandbox: true,
    appearance,
    onReady: () => undefined,
    onEvent: (event: any) => {
      if (event?.eventName === "CONSENT_CHECKBOX_CHANGE") {
        params.onCheckboxChange({
          isSelected: event.isSelected,
          actionToken: event.actionToken,
        });
      }
    },
  });

  consentBox.mount(params.containerSelector);
}
